const T = require('prop-types');

const internals = {};

internals.hasId = (value) => value !== undefined && value !== null;

internals.sameId = (a, b) => String(a) === String(b);

internals.userDetailsForDirectMessage = (props, propName, componentName) => {

    const userDetails = props[propName];
    const roleId = userDetails?.user?.role?.id;

    if (!userDetails || !userDetails.user) {
        return new Error(`${componentName} is waiting for ${propName}`);
    }

    if (!internals.hasId(roleId)) {
        return new Error(`${componentName} is waiting for ${propName}.user.role.id`);
    }

    return null;
};

internals.directMessageUsers = (props, propName, componentName) => {

    const users = props[propName];

    if (!Array.isArray(users) || !users.length) {
        return new Error(`${componentName} is waiting for ${propName}`);
    }

    const currentUserId = props.currentUser?.id;

    if (!internals.hasId(currentUserId)) {
        return new Error(`${componentName} is waiting for currentUser before validating ${propName}`);
    }

    const hasOtherParticipant = users.some((user) => {

        return internals.hasId(user?.id) && !internals.sameId(user.id, currentUserId);
    });

    if (!hasOtherParticipant) {
        return new Error(`${componentName} is waiting for ${propName} to include the other direct message participant`);
    }

    return null;
};

exports.hasDirectMessageDependencies = ({
    currentUser,
    header,
    rolePermissions,
    rolesInteractions,
    userDetails,
    users = []
}) => {

    if (!currentUser || !header || !rolePermissions || !Array.isArray(rolesInteractions)) {
        return false;
    }

    if (!internals.hasId(userDetails?.user?.role?.id)) {
        return false;
    }

    return users.some((user) => internals.hasId(user?.id)
        && !internals.sameId(user.id, currentUser.id));
};

exports.canLoadDirectMessageChat = ({ sid }) => typeof sid === 'string'
    && !!sid.trim()
    && !sid.startsWith('u:')
    && !['NaN', 'undefined', 'null'].includes(sid);

exports.dependencyPropTypes = {
    currentUser: T.object.isRequired,
    header: T.string.isRequired,
    rolePermissions: T.object.isRequired,
    rolesInteractions: T.array.isRequired,
    userDetails: internals.userDetailsForDirectMessage,
    users: internals.directMessageUsers
};

if (process.env.NODE_ENV === 'test') {
    exports._internals = internals;
}
